import React from "react";
import Benefit from "../shared/benefit/benefit";
import Loader from "../../components/common/loader";
import {AnalyticsParamValues} from "../../constants/analytics";

import './index.scss'
import {useParams} from "react-router-dom";
import {useGetBenefitsPageQuery} from "../../redux/api/content.api";
import ReactHtmlParser from "react-html-parser";
import {reactParserCommonOptions} from "../../app/functions";
import Page404 from "../page404";

export function BenefitsPage() {

    const params = useParams();

    const {data, isLoading, error} = useGetBenefitsPageQuery({
        name: params.name
    });



    if (isLoading) return (<Loader className="initial-loader"/>)
    if (!data?.benefits) return <Page404/>
    return (<main className='benefits-page_container'>
        <div id="free-search-wrapper" className="free-search-wrapper">
            <>
                <div className='result-wrapper'> {
                    data.header_html ? ReactHtmlParser(data.header_html, reactParserCommonOptions()) : null}
                </div>

                <div className="result-wrapper">
                    {(data.benefits || []).map((benefit) => (
                        <Benefit
                            key={benefit.id}
                            data={benefit}
                            analyticsSource={AnalyticsParamValues.SEARCH_RESULTS_SOURCE}
                        />
                    ))}

                </div>
            </>


        </div>
    </main>)
}
